import type { ReactNode } from 'react'

import { NotificationList } from '~/shared/ui'

type NotificationsProviderProps = {
  children: ReactNode
}

/**
 * Стек уведомлений — не React-контекст: показать уведомление можно вызовом
 * notifications.show/success/error/warning/info (shared/lib/notifications) из любого места,
 * стор живёт вне React. Этот компонент только монтирует список поверх дерева приложения —
 * реализация живёт в ~/shared/ui (docs/architecture.md §2.1).
 */
export function NotificationsProvider(props: NotificationsProviderProps) {
  const { children } = props

  return (
    <>
      {children}
      <NotificationList />
    </>
  )
}
